import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const API_BASE_URL = process.env.REACT_APP_API_URL || "https://phulhar-dham.onrender.com";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/forgotpassword`, { email });
      
      if (response.data.success || response.status === 200) {
        setMessage('पासवर्ड रीसेट लिंक आपके ईमेल पर भेज दिया गया है।');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'कुछ गलत हुआ। कृपया पुनः प्रयास करें।');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-temple-bg flex items-center justify-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 sm:space-y-8">
        <div className="text-center">
          <div className="text-4xl sm:text-6xl mb-4">🔑</div>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-temple-text">
            पासवर्ड भूल गए?
          </h2>
          <p className="mt-2 text-temple-text-muted text-sm sm:text-base">
            पासवर्ड रीसेट करने के लिए अपना ईमेल दर्ज करें
          </p>
        </div>

        <div className="bg-temple-bg-warm rounded-3xl shadow-temple p-6 sm:p-8 border border-temple-primary/10">
          {message && (
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm mb-6 text-center font-bold">
              {message}
            </div>
          )}

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm mb-6 text-center font-bold">
              {error}
            </div>
          )}

          {!message && (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-bold text-temple-text mb-2">
                  ईमेल पता
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-3 border-2 border-temple-primary/20 rounded-lg focus:ring-0 focus:border-temple-primary transition bg-temple-bg"
                  placeholder="आपका ईमेल पता"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full btn-temple-primary py-3 px-4 rounded-xl font-bold text-base sm:text-lg disabled:opacity-50"
              >
                {loading ? 'प्रक्रिया जारी है...' : 'रीसेट लिंक भेजें'}
              </button>
            </form>
          )}

          <div className="text-center mt-6">
            <Link to="/login" className="text-temple-primary hover:text-temple-primary-dark font-medium text-sm">
              ← वापस लॉगिन पर जाएं
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
